import React from 'react'
import PropTypes from 'prop-types'
import { DragLayer } from 'react-dnd'

import { DND_TYPE } from './constants'

import EntityPreview from '../components/Entity/dndPreview'
import GroupEntityPreview from '../components/GroupEntity/dndPreview'

import './style.scss'

@DragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
}))
export default class CustomDragLayer extends React.Component {
    static propTypes = {
        currentOffset: PropTypes.shape({
            x: PropTypes.number.isRequired,
            y: PropTypes.number.isRequired,
        }),
        isDragging: PropTypes.bool.isRequired,
        item: PropTypes.object,
        itemType: PropTypes.string,
    }

    getItemStyles = () => {
        const { currentOffset } = this.props
        if (!currentOffset) return { display: 'none' }

        const { x, y } = currentOffset
        const transform = `translate(${x}px, ${y}px)`

        return {
            transform,
        }
    }

    renderItem() {
        const { itemType, item } = this.props

        switch (itemType) {
            case DND_TYPE.ENTITY:
                return <EntityPreview entity={item.entity} />
            case DND_TYPE.GROUP:
                return <GroupEntityPreview name={item.name} count={item.count} />
            default:
                return null
        }
    }

    render() {
        const { item, itemType, isDragging } = this.props

        if (!isDragging) return null

        return (
            <div className={'dnd-drag-layer'}>
                <div style={this.getItemStyles()}>{this.renderItem(itemType, item)}</div>
            </div>
        )
    }
}
